import { Map } from 'immutable';

import WorkspaceRecentUpdatesConstants from 'Shared/constants/WorkspaceRecentUpdates.constants';

class WorkspaceRecentUpdatesHelper {
  static getId(workspaceRecentUpdate) {
    if (!Map.isMap(workspaceRecentUpdate)) {
      return false;
    }
    return workspaceRecentUpdate.get(WorkspaceRecentUpdatesConstants.Model.ID);
  }

  static getType(workspaceRecentUpdate) {
    if (!Map.isMap(workspaceRecentUpdate)) {
      return false;
    }
    return workspaceRecentUpdate.get(WorkspaceRecentUpdatesConstants.Model.TYPE);
  }

  static getTime(workspaceRecentUpdate) {
    if (!Map.isMap(workspaceRecentUpdate)) {
      return false;
    }
    return workspaceRecentUpdate.get(WorkspaceRecentUpdatesConstants.Model.TIME);
  }

  static getUserId(workspaceRecentUpdate) {
    if (!Map.isMap(workspaceRecentUpdate)) {
      return false;
    }
    return workspaceRecentUpdate.get(WorkspaceRecentUpdatesConstants.Model.USER_ID);
  }

  static getMeetingItemUuid(workspaceRecentUpdate) {
    if (!Map.isMap(workspaceRecentUpdate)) {
      return false;
    }
    return workspaceRecentUpdate.get(WorkspaceRecentUpdatesConstants.Model.MEETING_ITEM_UUID);
  }

  static getWorkspaceSlug(workspaceRecentUpdate) {
    if (!Map.isMap(workspaceRecentUpdate)) {
      return false;
    }
    return workspaceRecentUpdate.get(WorkspaceRecentUpdatesConstants.Model.WORKSPACE_SLUG);
  }

  static getWorkspaceCommentUuid(workspaceRecentUpdate) {
    if (!Map.isMap(workspaceRecentUpdate)) {
      return false;
    }
    return workspaceRecentUpdate.get(WorkspaceRecentUpdatesConstants.Model.WORKSPACE_COMMENT_UUID);
  }

  static getIsNew(workspaceRecentUpdate) {
    if (!Map.isMap(workspaceRecentUpdate)) {
      return false;
    }
    return workspaceRecentUpdate.get(WorkspaceRecentUpdatesConstants.Model.IS_NEW);
  }

  static getAssigneeName(workspaceRecentUpdate) {
    if (!Map.isMap(workspaceRecentUpdate)) {
      return false;
    }
    return workspaceRecentUpdate.getIn([
      WorkspaceRecentUpdatesConstants.Model.DATA,
      WorkspaceRecentUpdatesConstants.Model.ASSIGNEE_NAME,
    ]);
  }
}

export default WorkspaceRecentUpdatesHelper;
